export default {
   
    datosExcel(vm) {
        const request = new FormData()
        request.append("datos", JSON.stringify(vm.data))
        request.append("flclave", vm.flotillas.flclave.flclave)
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/DatosExcel`, request, { timeout: 1000000 }).then(response => response.data)
    },

    validardatosExcel(vm) {
        const request = new FormData()
        request.append("datos", JSON.stringify(vm.data))
        request.append("flclave", vm.flotillas.flclave.flclave)
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/ValidarDatosExcel`, request, { timeout: 1000000 }).then(response => response.data)
    },
    obtenerflotillas(vm) {
        vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/ObtenerFlotillas`).then(response => {
            vm.flotillas.opcionesFlotillas = response.data;
        })
    },
    enviosdesms(vm,data) {
        const request = new FormData()
        request.append("datos", JSON.stringify(data))
        request.append("flclave", vm.flotillas.flclave.flclave)
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/EnviarSMSReportes`, request, { timeout: 1000000 }).then(response => response.data)
    },
    enviosdecorreos(vm, data) {
        const request = new FormData()
        request.append("datos", JSON.stringify(data))
        request.append("flclave", vm.flotillas.flclave.flclave)
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/EnviarCorreosReportes`, request, { timeout: 1000000 }).then(response => response.data)
    },
    descargarExcelReportes(vm) {
        return vm.axios.post(`${vm.domain.domainNameForApi}CargaLayout/descargarExcel`,).then(response => response.data)
    },
}